export { default } from './language-selector-modal-contents';
